(function(){
  var productPrice = window.productPrice1 || 0;
  var productCurrency = 'EUR';
  var currentLang  = document.documentElement.lang || 'en';
  console.log(currentLang);
  
  var langToCountryMap = {
    'fr': 'FR',
    'it': 'IT',
    'es': 'ES',
  };
  var buyerCountry = langToCountryMap[currentLang];

  var supportedCountries = ['FR', 'IT', 'ES'];

  if (!buyerCountry || !supportedCountries.includes(buyerCountry)) {
    return;
  }
  
  var components = 'buttons,messages';
  var plMsgSelector = '.pmsg-div';

  var cid = 'AYhgfIDW7RXcK9xp-0kNAMnxF8TFtqWorS8xTrUrID16zbPZHWl4Cpfhqnu3AF85YwmqPzMwvHL53Ms8';

  var jssdkTag = document.createElement('script');
  jssdkTag.setAttribute("data-namespace", "paypal_sdk");
  jssdkTag.async = true;
  jssdkTag.src = 'https://www.paypal.com/sdk/js?client-id=' + cid
                  + '&components=' + components
                  + '&currency=' + productCurrency;
  jssdkTag.onload = function(){
      paypal_sdk.Messages({
        amount: productPrice,
        placement: "product",
        buyerCountry: buyerCountry,
        style: {
          layout: "text",
          logo: {
            type: "inline"
          },
          text: {
            size: "12",
            color: "black"
          }
        }
      }).render(plMsgSelector);
	
  };

  document.getElementsByTagName('script')[0].parentNode.insertBefore(jssdkTag, document.getElementsByTagName('script')[0]);
	  
})();